import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule,
  MatCardModule,
  MatDatepickerModule,
  MatFormFieldModule,
  MatIconModule,
  MatInputModule,
  MatMenuModule,
  MatSnackBarModule,
  MatSortModule,
  MatTableModule,
  MatTabsModule,
  MatDialogModule,
  MatDialog
} from '@angular/material';
import { downgradeComponent } from '@angular/upgrade/static';
import { ApiModule } from 'src/app/api';
import { MaskModule } from '@mandae/ng-utils/mask';
import { StateProvider } from '@uirouter/angularjs';
import * as angular from 'angular';
import { DashboardModule } from '../dashboard/dashboard.module';
import { ServicesModule } from '../services/services.module';
import { CollectionComponent } from './collection/collection.component';
import { CountersComponent } from './counters/counters.component';
import { DashboardComponent } from './dashboard/dashboard.component';
import { FinancialComponent } from './financial/financial.component';
import { HomeRoutingModule } from './home-routing.module';
import { IndicatorsComponent } from './indicators/indicators.component';
import { DialogsModule } from '../dialogs/dialogs.module';
import { ModalComunicadosComponent } from './dashboard/notificacao/comunicados/modal.component';

@NgModule({
  declarations: [
    DashboardComponent,
    CountersComponent,
    CollectionComponent,
    FinancialComponent,
    IndicatorsComponent,
    ModalComunicadosComponent
  ],
  entryComponents: [
    DashboardComponent,
    ModalComunicadosComponent
  ],
  imports: [
    CommonModule,
    DashboardModule,
    ApiModule,
    HomeRoutingModule,
    ReactiveFormsModule,
    FlexLayoutModule,
    ServicesModule,
    MaskModule,
    DialogsModule,
    MatButtonModule,
    MatDialogModule,
    MatCardModule,
    MatDatepickerModule,
    MatFormFieldModule,
    MatIconModule,
    MatInputModule,
    MatMenuModule,
    MatSnackBarModule,
    MatSortModule,
    MatTableModule,
    MatTabsModule,
  ]
})
export class HomeModule { }

try {
  angular
    .module('mandaeApp')
    .directive('appHomeDashboard', downgradeComponent({ component: DashboardComponent }))
    .config([ '$stateProvider', ($stateProvider: StateProvider) => {
      $stateProvider
        .state({
          name: 'home',
          url: '/home',
          component: 'appHomeDashboard',
        });
    }]);
} catch (e) {}
